import React, { useState, useEffect } from 'react';
import config from '../../config/config';
import Container from 'react-bootstrap/Container';
import { Dropdown, Navbar, Nav } from 'react-bootstrap';
import '../componentCss/dashboardheader.css';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { decryptData } from './decrypt';
import {
    getStaffDetailsAction
} from "../../Action/admin.action";
import NotificationBell from '../../components/notifications/NotificationBell';
import { 
    FaUser, 
    FaLock, 
    FaSignOutAlt, 
    FaChevronDown,
    FaUserCircle 
} from 'react-icons/fa';

const Dashboardheader = () => {
    // Read from localStorage instead of cookies to match other components
    let loginData = null;
    try {
        const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
        if (storageData) {
            loginData = JSON.parse(storageData);
        }
    } catch (error) {
        loginData = null;
    }

    const navigate = useNavigate();
    const getStaffData = useSelector((state) => state.user?.getStaffDetailsData);
    const logout = async () => {
        localStorage.removeItem("loginSuccessNeurulaHealth");
        window.location.href = `${config.baseUrl}`;
    };

    const [staffDetails, setStaffDetails] = useState([]);

    // useEffect(() => {
    //     if (getStaffData && getStaffData.data) {
    //         setStaffDetails(getStaffData.data);
    //     } else {
    //         getStaffDetailsAPI();
    //     }
    // }, [getStaffData]);

    useEffect(() => {
        getStaffDetailsAPI();
    }, [loginData?.id]);


    useEffect(() => {
        updateExpireTime();
        window.addEventListener("click", updateExpireTime);
        window.addEventListener("scroll", updateExpireTime);
        window.addEventListener("keypress", updateExpireTime);
        window.addEventListener("mousemove", updateExpireTime);

        return () => {
            window.removeEventListener("click", updateExpireTime);
            window.removeEventListener("scroll", updateExpireTime);
            window.removeEventListener("keypress", updateExpireTime);
            window.removeEventListener("mousemove", updateExpireTime);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            checkForInactivity();
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const checkForInactivity = () => {
        const expireTime = localStorage.getItem("expireTime");
        if (expireTime < Date.now()) {
            logout();
        }
    };

    const updateExpireTime = () => {
        const expireTime = Date.now() + 15 * 60 * 1000;
        localStorage.setItem("expireTime", expireTime);
    };

    const getStaffDetailsAPI = async () => {
        let res = await getStaffDetailsAction(loginData?.id);
        if (res.success) {
            setStaffDetails(decryptData(res.data));
        }

        // const res = await dispatch(getStaffDetails({ id: loginData?.id }));
        // if (res.payload?.success) {
        //     setStaffDetails(res.payload.data);
        // }
    };


    return (
        <>
            <header className='dashboardheader'>
                <Navbar expand="lg">
                    <Container fluid className='px-5'>
                        <Navbar.Brand href={`${config.baseUrl}`}>
                            <span><img src='assets/images/logo2.png' className='mainlogo' alt='logo2' /></span>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav className="mx-auto my-2 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
                            </Nav>
                            <NotificationBell userId={loginData?.id} />
                            <div className='admindropdoen'>
                                <Dropdown className='flagdrop user-dropdown'>
                                    <Dropdown.Toggle variant="" id="dropdown-basic" className='adminbtn user-dropdown-toggle'>
                                        <div className="user-info">
                                            <FaUserCircle className='user-avatar-icon' />
                                            <span className="user-name">{`${staffDetails?.firstName ? staffDetails?.firstName : ''} ${staffDetails?.lastName ? staffDetails?.lastName : ''}`}</span>
                                            <FaChevronDown className="dropdown-chevron" />
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="modern-dropdown-menu">
                                        <div className="dropdown-header">
                                            <FaUserCircle className="header-avatar" />
                                            <div className="user-details">
                                                <span className="user-full-name">{`${staffDetails?.firstName ? staffDetails?.firstName : ''} ${staffDetails?.lastName ? staffDetails?.lastName : ''}`}</span>
                                                <span className="user-role">Healthcare Professional</span>
                                            </div>
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <Dropdown.Item className="modern-dropdown-item">
                                            <Link to={`${config.baseUrl}profile`} className='header-links'>
                                                <FaUser className="menu-icon" />
                                                <span className="menu-text">My Profile</span>
                                            </Link>
                                        </Dropdown.Item>
                                        <Dropdown.Item className="modern-dropdown-item">
                                            <Link to={`${config.baseUrl}changePassword`} className='header-links'>
                                                <FaLock className="menu-icon" />
                                                <span className="menu-text">Change Password</span>
                                            </Link>
                                        </Dropdown.Item>
                                        <div className="dropdown-divider"></div>
                                        <Dropdown.Item className="modern-dropdown-item logout-item" onClick={logout}>
                                            <FaSignOutAlt className="menu-icon logout-icon" />
                                            <span className="menu-text">Logout</span>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>
        </>
    );
};

export default Dashboardheader;
